<template>
  <div class="chat-mensagens d-flex flex-column h-100">
    <!-- Área de mensagens -->
    <div
      ref="mensagens"
      class="mensagens flex-grow-1 overflow-auto p-2"
    >
      <div
        v-for="msg in mensagens"
        :key="msg._id"
        :class="[
          'mensagem p-2 mb-2 rounded',
          msg.remetente.id === usuarioLogado.id ? 'bg-primary text-white align-self-end' : 'bg-light align-self-start'
        ]"
      >
        <small
          v-if="msg.remetente.id !== usuarioLogado.id"
          class="text-muted d-block"
        >{{ msg.remetente.nome }}</small>

        <!-- Conteúdo de mídia -->
        <div v-if="msg.url && msg.type !== 'texto' && msg.type !== 'text'">
          <!-- Imagem -->
          <div v-if="getMidiaType(msg) === 'image'">
            <img
              :src="msg.url"
              class="midia-imagem rounded mb-2"
              alt="Imagem"
              @click="abrirMidiaModal(msg.url, 'image')"
            />
          </div>

          <!-- Vídeo -->
          <div v-else-if="getMidiaType(msg) === 'video'">
            <video
              :src="msg.url"
              class="midia-video rounded mb-2"
              controls
            />
          </div>

          <!-- Áudio -->
          <div v-else-if="getMidiaType(msg) === 'audio'">
            <audio
              :src="msg.url"
              class="midia-audio mb-2"
              controls
            />
          </div>

          <!-- PDF ou outros documentos -->
          <div v-else-if="getMidiaType(msg) === 'document'">
            <a
              :href="msg.url"
              target="_blank"
              class="documento-link d-flex align-items-center"
            >
              <feather-icon
                icon="FileTextIcon"
                size="20"
                class="mr-2"
              />
              <span>Visualizar documento</span>
            </a>
          </div>

          <!-- Arquivo genérico -->
          <div v-else>
            <a
              :href="msg.url"
              target="_blank"
              class="documento-link d-flex align-items-center"
            >
              <feather-icon
                icon="FileIcon"
                size="20"
                class="mr-2"
              />
              <span>Download arquivo</span>
            </a>
          </div>

          <!-- Texto que acompanha a mídia -->
          <div v-if="msg.text || msg.texto">
            {{ msg.text || msg.texto }}
          </div>
        </div>

        <!-- Mensagem de texto simples -->
        <div v-else>
          {{ msg.text || msg.texto }}
        </div>

        <!-- Status de envio -->
        <div
          v-if="msg.status"
          class="text-right small mt-1"
        >
          <span v-if="msg.status === 'enviando'">
            <feather-icon
              icon="ClockIcon"
              size="12"
            />
            Enviando...
          </span>
          <span
            v-else-if="msg.status === 'erro'"
            class="text-danger"
          >
            <feather-icon
              icon="AlertCircleIcon"
              size="12"
            />
            Erro
          </span>
        </div>

        <div class="text-right text-muted small mt-1">
          {{ formatarHora(msg.timestamp) }}
        </div>
      </div>
    </div>

    <!-- Input -->
    <InputMensagem
      @enviar="enviarMensagem"
      @enviar-midia="enviarMidia"
    />

    <!-- Modal para visualizar mídia em tela cheia -->
    <b-modal
      v-model="midiaModalVisivel"
      size="xl"
      centered
      hide-footer
      title="Visualizar Mídia"
    >
      <div class="text-center">
        <img
          v-if="midiaModalTipo === 'image'"
          :src="midiaModalUrl"
          class="img-fluid"
          alt="Imagem"
        />
        <video
          v-else-if="midiaModalTipo === 'video'"
          :src="midiaModalUrl"
          class="w-100"
          controls
          autoplay
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import InputMensagem from './InputMensagem.vue'
import { enviarMidiaGrupo, enviarMidiaIndividual } from '../../../functions/basics/chat-interno'
import { BModal } from 'bootstrap-vue'
import { FeatherIcon } from 'vue-feather-icons'

export default {
  components: { 
    InputMensagem,
    BModal,
    FeatherIcon,
  },
  props: ['conversa', 'usuarioLogado'],
  data() {
    return {
      mensagens: [
        // Simulação inicial
        {
          _id: '1',
          texto: 'Olá! Tudo bem?',
          timestamp: new Date(),
          remetente: { id: 2, nome: 'Fernanda' },
          type: 'texto',
        },
        {
          _id: '2',
          texto: 'Tudo ótimo e contigo?',
          timestamp: new Date(),
          remetente: { id: 1, nome: 'Romário' },
          type: 'texto',
        },
      ],
      midiaModalVisivel: false,
      midiaModalUrl: null,
      midiaModalTipo: null,
    }
  },
  methods: {
    enviarMensagem(texto) {
      const nova = {
        _id: Date.now().toString(),
        texto,
        text: texto,
        timestamp: new Date(),
        remetente: this.usuarioLogado,
        type: 'texto',
      }

      this.mensagens.push(nova)

      // Aqui futuramente: socket.emit("nova_mensagem", { ... })

      this.$nextTick(() => {
        const el = this.$refs.mensagens
        el.scrollTop = el.scrollHeight
      })
    },

    async enviarMidia({ arquivo, texto, onProgress }) {
      // Criar mensagem temporária para mostrar o progresso
      const msgTemporaria = {
        _id: Date.now().toString(),
        texto: texto || 'Enviando mídia...',
        text: texto || 'Enviando mídia...',
        timestamp: new Date(),
        remetente: this.usuarioLogado,
        status: 'enviando',
        type: this.getTipoMidia(arquivo),
      }

      this.mensagens.push(msgTemporaria)
      this.scrollToBottom()

      try {
        // Obter chatId (UUID da conta)
        const chatId = this.$route.params.uuid
        
        console.log('📤 Enviando mídia...', {
          arquivo: arquivo.name,
          tipo: arquivo.type,
          tamanho: arquivo.size,
          texto,
          chatId,
          usuarioId: this.usuarioLogado.id,
          conversa: this.conversa,
        })
        
        let resposta

        // Verificar se é grupo ou individual
        if (this.conversa.tipo === 'grupo') {
          resposta = await enviarMidiaGrupo(
            chatId,
            arquivo,
            texto,
            this.usuarioLogado.id,
            onProgress
          )
        } else {
          // Chat individual
          resposta = await enviarMidiaIndividual(
            chatId,
            this.conversa.id, // receiverId
            arquivo,
            texto,
            this.usuarioLogado.id,
            onProgress
          )
        }

        console.log('📥 Resposta do servidor:', resposta)

        // Verificar o formato da resposta
        // Formato esperado original: { success, mensagem: {...}, mediaUrl, mediaType }
        // Formato alternativo: { success, type, url, ... }
        
        let mensagemFinal
        
        if (resposta.mensagem) {
          // Formato completo com mensagem
          mensagemFinal = {
            _id: resposta.mensagem._id || Date.now().toString(),
            texto: resposta.mensagem.text || texto || '',
            text: resposta.mensagem.text || texto || '',
            timestamp: resposta.mensagem.timestamp || new Date(),
            remetente: this.usuarioLogado,
            url: resposta.mediaUrl || resposta.mensagem.url,
            mediaType: resposta.mediaType || resposta.mensagem.type,
            type: resposta.mensagem.type,
            status: 'enviado',
          }
        } else if (resposta.url) {
          // Formato simplificado (apenas upload)
          // Deduzir o tipo pela extensão da URL se o tipo for genérico
          let tipoFinal = resposta.type || this.getTipoMidia(arquivo)
          
          if (tipoFinal === 'file' && resposta.url) {
            // Tentar deduzir pela extensão do arquivo
            const url = resposta.url.toLowerCase()
            if (url.match(/\.(jpg|jpeg|png|gif|webp|bmp|svg)$/)) {
              tipoFinal = 'image'
            } else if (url.match(/\.(mp4|webm|ogg|mov|avi)$/)) {
              tipoFinal = 'video'
            } else if (url.match(/\.(mp3|wav|ogg|m4a)$/)) {
              tipoFinal = 'audio'
            } else if (url.match(/\.pdf$/)) {
              tipoFinal = 'document'
            }
          }
          
          mensagemFinal = {
            _id: Date.now().toString(),
            texto: texto || '',
            text: texto || '',
            timestamp: new Date(),
            remetente: this.usuarioLogado,
            url: resposta.url,
            mediaType: tipoFinal,
            type: tipoFinal,
            status: 'enviado',
          }
        } else {
          throw new Error('Formato de resposta inválido')
        }

        // Atualizar mensagem temporária com a resposta do servidor
        const index = this.mensagens.findIndex(m => m._id === msgTemporaria._id)
        if (index !== -1) {
          this.mensagens[index] = mensagemFinal
        }

        console.log('✅ Mensagem atualizada:', this.mensagens[index])

        this.scrollToBottom()
        
        this.$bvToast.toast('Mídia enviada com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        })
      } catch (error) {
        console.error('❌ Erro ao enviar mídia:', error)
        console.error('❌ Detalhes do erro:', error.response?.data || error.message)
        
        // Atualizar mensagem temporária com erro
        const index = this.mensagens.findIndex(m => m._id === msgTemporaria._id)
        if (index !== -1) {
          this.mensagens[index].status = 'erro'
        }

        this.$bvToast.toast('Erro ao enviar mídia. Tente novamente.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
      }
    },

    getTipoMidia(arquivo) {
      const tipo = arquivo.type
      if (tipo.startsWith('image/')) return 'image'
      if (tipo.startsWith('video/')) return 'video'
      if (tipo.startsWith('audio/')) return 'audio'
      if (tipo === 'application/pdf') return 'document'
      return 'file'
    },

    getMidiaType(msg) {
      // Priorizar mediaType se existir
      if (msg.mediaType) {
        const tipo = msg.mediaType.toLowerCase()
        if (tipo === 'image') return 'image'
        if (tipo === 'video') return 'video'
        if (tipo === 'audio') return 'audio'
        if (tipo === 'document' || tipo === 'pdf') return 'document'
      }
      
      // Verificar o campo type
      if (msg.type) {
        const tipo = msg.type.toLowerCase()
        if (tipo === 'image') return 'image'
        if (tipo === 'video') return 'video'
        if (tipo === 'audio') return 'audio'
        if (tipo === 'document' || tipo === 'pdf' || tipo === 'file') return 'document'
      }
      
      // Tentar deduzir pela URL
      if (msg.url) {
        const url = msg.url.toLowerCase()
        if (url.match(/\.(jpg|jpeg|png|gif|webp|bmp|svg)$/)) return 'image'
        if (url.match(/\.(mp4|webm|ogg|mov|avi)$/)) return 'video'
        if (url.match(/\.(mp3|wav|ogg|m4a)$/)) return 'audio'
        if (url.match(/\.pdf$/)) return 'document'
      }
      
      return 'file'
    },

    abrirMidiaModal(url, tipo) {
      this.midiaModalUrl = url
      this.midiaModalTipo = tipo
      this.midiaModalVisivel = true
    },

    scrollToBottom() {
      this.$nextTick(() => {
        const el = this.$refs.mensagens
        if (el) {
          el.scrollTop = el.scrollHeight
        }
      })
    },

    formatarHora(data) {
      return new Date(data).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    },
  },
}
</script>

<style scoped>
.chat-mensagens {
  height: 100%;
}

.mensagens {
  min-height: 0; /* Importante para evitar estourar */
}

.midia-imagem {
  max-width: 250px;
  max-height: 250px;
  object-fit: cover;
  cursor: pointer;
  transition: transform 0.2s;
}

.midia-imagem:hover {
  transform: scale(1.02);
}

.midia-video {
  max-width: 250px;
  max-height: 250px;
}

.midia-audio {
  width: 100%;
  max-width: 250px;
}

.documento-link {
  color: inherit;
  text-decoration: none;
  padding: 8px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  transition: background-color 0.2s;
}

.documento-link:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.bg-primary .documento-link {
  color: white;
}

.bg-light .documento-link {
  color: #333;
  border-color: rgba(0, 0, 0, 0.1);
}
</style>
